// src/components/Navbar.jsx
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { FaHome, FaMapMarkedAlt, FaBars, FaTimes, FaBook } from "react-icons/fa";

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [openSubmenu, setOpenSubmenu] = useState(null);

  const toggleSubmenu = (menu) => {
    setOpenSubmenu(openSubmenu === menu ? null : menu);
  };

  return (
    <nav className="bg-[#0f172a] text-white shadow-md sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-6 py-4 flex justify-between items-center">
        {/* Logo */}
        <Link to="/" className="flex items-center space-x-2">
          <img src="/images/logo.png" alt="Logo" className="h-10" />
          <span className="font-bold text-xl"> </span>
        </Link>

        {/* Desktop Menu */}
        <ul className="hidden md:flex space-x-6 items-center">
          <li>
            <Link to="/" className="flex items-center space-x-2 hover:text-sky-400">
              <FaHome /> <span>Inicio</span>
            </Link>
          </li>

          {/* Submenu Regiones */}
          <li className="relative group">
            <button
              onClick={() => toggleSubmenu("regiones")}
              className="flex items-center space-x-2 hover:text-sky-400 focus:outline-none"
            >
              <FaMapMarkedAlt /> <span>Regiones</span>
            </button>
            {openSubmenu === "regiones" && (
              <ul
                onMouseLeave={() => setOpenSubmenu(null)}
                className="absolute left-0 mt-2 w-56 bg-white text-[#0f172a] shadow-lg rounded-lg p-2 space-y-2 z-50"
              >
                <li><Link to="/costalegre" className="block px-4 py-2 hover:bg-sky-100">Costalegre</Link></li>
                <li><Link to="/chapala" className="block px-4 py-2 hover:bg-sky-100">Chapala</Link></li>
                <li><Link to="/rioverde" className="block px-4 py-2 hover:bg-sky-100">Río Verde</Link></li>
                <li><Link to="/tapalpa" className="block px-4 py-2 hover:bg-sky-100">Tapalpa</Link></li>
                
                <li><Link to="/altosnorte" className="block px-4 py-2 hover:bg-sky-100">Altos Norte</Link></li>
                <li><Link to="/paisajeagavero" className="block px-4 py-2 hover:bg-sky-100">Paisaje Agavero</Link></li>
                <li><Link to="/cacs" className="block px-4 py-2 hover:bg-sky-100">Cuenca Alta de la Costa Sur</Link></li>
                <li><Link to="/lagunas" className="block px-4 py-2 hover:bg-sky-100">Lagunas</Link></li>
                <li><Link to="/sierraoccidental" className="block px-4 py-2 hover:bg-sky-100">Sierra Occidental</Link></li>
                <li><Link to="/sierradeltigre" className="block px-4 py-2 hover:bg-sky-100">Sierra del Tigre</Link></li> 
                <li><Link to="/riozula" className="block px-4 py-2 hover:bg-sky-100">Río Zula</Link></li>
                <li><Link to="/JIRA" className="block px-4 py-2 hover:bg-sky-100">JIRA</Link></li>
                

                {/* <li><Link to="/centro" className="block px-4 py-2 hover:bg-sky-100">Centro</Link></li>
                <li><Link to="/sur" className="block px-4 py-2 hover:bg-sky-100">Sur</Link></li>
                <li><Link to="/norte" className="block px-4 py-2 hover:bg-sky-100">Norte</Link></li> */}
              </ul>
            )}
          </li>

          {/* Submenu Ordenamiento Territorial */}
          <li className="relative group">
            <button
              onClick={() => toggleSubmenu("ordenamiento")}
              className="flex items-center space-x-2 hover:text-sky-400 focus:outline-none"
            >
              <FaBook /> <span>Ordenamiento Estatal</span>
            </button>
            {openSubmenu === "ordenamiento" && (
              <ul
                onMouseLeave={() => setOpenSubmenu(null)}
                className="absolute left-0 mt-2 w-64 bg-white text-[#0f172a] shadow-lg rounded-lg p-2 space-y-2 z-50"
              >
                <li><Link to="https://sigat.semadet.jalisco.gob.mx/ordenamiento/POET.html" className="block px-4 py-2 hover:bg-sky-100">Estatal Historico</Link></li>
                 <li><Link to="https://siga.jalisco.gob.mx/biblioteca/" className="block px-4 py-2 hover:bg-sky-100">Biblioteca</Link></li>
                {/*<li><Link to="https://siga.jalisco.gob.mx/planesDUM23/counter" className="block px-4 py-2 hover:bg-sky-100">Municipal</Link></li>
                <li><Link to="https://siga.jalisco.gob.mx/ordenamiento/archivos/EtapasPDU/Manual_para_promover_PyPDU.pdf" className="block px-4 py-2 hover:bg-sky-100">Manual PyPDU</Link></li> */}
              </ul>
            )}
          </li>

          <li>
            {/* <Link to="/contacto" className="hover:text-sky-400">Contacto</Link> */}
          </li>
        </ul>

        {/* Mobile Button */}
        <button
          onClick={() => setMenuOpen(!menuOpen)}
          className="md:hidden text-2xl focus:outline-none"
        >
          {menuOpen ? <FaTimes /> : <FaBars />}
        </button>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="md:hidden bg-[#0f172a] px-6 py-4 space-y-4">
          <Link to="/" onClick={() => setMenuOpen(false)} className="block hover:text-sky-400">
            Inicio
          </Link>

          {/* Regiones */}
          <button
            onClick={() => toggleSubmenu("regiones")}
            className="w-full text-left hover:text-sky-400"
          >
            Regiones {openSubmenu === "regiones" ? "−" : "+"}
          </button>
          {openSubmenu === "regiones" && (
            <ul className="ml-4 space-y-2">
              <li><Link to="/costalegre" onClick={() => setMenuOpen(false)}>Costalegre</Link></li>
              <li><Link to="/chapala" onClick={() => setMenuOpen(false)}>Chapala</Link></li>
              <li><Link to="/rioverde" onClick={() => setMenuOpen(false)}>Río Verde</Link></li>
              <li><Link to="/tapalpa" onClick={() => setMenuOpen(false)}>Tapalpa</Link></li>
              <li><Link to="/altosnorte" onClick={() => setMenuOpen(false)}>Altos Norte</Link></li>
              <li><Link to="/altossur" onClick={() => setMenuOpen(false)}>Altos Sur</Link></li>
              <li><Link to="/lagunas" onClick={() => setMenuOpen(false)}>Lagunas</Link></li>
              <li><Link to="/sierraoccidental" onClick={() => setMenuOpen(false)}>Sierra Occidental</Link></li>
              <li><Link to="/sierraamula" onClick={() => setMenuOpen(false)}>Sierra de Amula</Link></li>
              <li><Link to="/valles" onClick={() => setMenuOpen(false)}>Valles</Link></li>
              <li><Link to="/centro" onClick={() => setMenuOpen(false)}>Centro</Link></li>
              <li><Link to="/sur" onClick={() => setMenuOpen(false)}>Sur</Link></li>
              <li><Link to="/norte" onClick={() => setMenuOpen(false)}>Norte</Link></li>
            </ul>
          )}

          {/* Ordenamiento Territorial */}
          <button
            onClick={() => toggleSubmenu("ordenamiento")}
            className="w-full text-left hover:text-sky-400"
          >
            Ordenamiento Estatal {openSubmenu === "ordenamiento" ? "−" : "+"}
          </button>
          {openSubmenu === "ordenamiento" && (
            <ul className="ml-4 space-y-2">
              <li><Link to="/ordenamiento/estatal" onClick={() => setMenuOpen(false)}>Estatal</Link></li>
              <li><Link to="/ordenamiento/regional" onClick={() => setMenuOpen(false)}>Regional</Link></li>
              <li><Link to="/ordenamiento/municipal" onClick={() => setMenuOpen(false)}>Municipal</Link></li>
              <li><Link to="/ordenamiento/manual" onClick={() => setMenuOpen(false)}>Manual PyPDU</Link></li>
            </ul>
          )}

          <Link to="/contacto" onClick={() => setMenuOpen(false)} className="block hover:text-sky-400">
            Contacto
          </Link>
        </div>
      )}
    </nav>
  );
}
